import React from "react";
import ComingSoon from "../../components/ComingSoon";

export default function Industry() {
  return <ComingSoon title="Industries We Serve" />;
}
